/**
 * Where each node is in its growth, published once per frame by the renderer.
 *
 * The text overlay needs this for one reason: a caption must not appear before
 * the thing it names. A node is added to the session the moment the model emits
 * it, but on screen its strand still has to probe and extend for a couple of
 * seconds before the node lands. Showing the label at emission put words on an
 * empty patch of canvas — floating text, attached to nothing, which is exactly
 * what the growth animation is supposed to avoid.
 *
 * The renderer already resolves both halves of this — the effective birth (which
 * replay rewrites) and the phase durations (which tempo and reduced-motion
 * change) — so it publishes them rather than having the overlay reimplement the
 * same arithmetic and drift out of step with it.
 */
export const growth = {
  /** Effective birth for a node, accounting for timeline replay. */
  bornAt: (_id: string, birth: number): number => birth,
  /** Milliseconds from birth to the node touching down. */
  landsAfter: 0,
  /**
   * True when the user has asked for reduced motion.
   *
   * The renderer collapses its own phases to almost nothing in that mode, and
   * the global stylesheet crushes every transition — but the caption's fade is
   * a plain number in the frame loop and would keep running at full length.
   * The node would snap into being and the word would drift in behind it,
   * which is the exact desync this module exists to prevent.
   */
  calm: false,
}
